<template>
  <div class="administrative-regions" ref="administrativeRegions">
    <read-text v-if='isPureText' :value="regionText"></read-text>
    <template v-else>
      <RegionTreeCascade
      v-bind="{ ...$props }"
      :api="cityApi"
      :height="height"
      :selectedIds="selectedIds"
      :placeholder="placeholder"
      :wholeCountry="true"
      class="sy-region"
      :size="size"
      @updateArea="updateArea"
      v-if="multiple || !radio"
    />
    <scity
      v-bind="{ ...$props }"
      :disable="disabled"
      :optionalTabs="optionalTabs"
      :api="cityApi"
      :placeholder="placeholder"
      @input="changeArea"
      @clearAll="clearAll"
      :data="areaData"
      v-else
    />
    </template>
  </div>
</template>

<script>
  import scity from '../../../../../basis/area/index.vue'
  import RegionTreeCascade from './region-tree-cascade/index.vue'
  import Api from './api'
  import {regionProps, initValue} from './index.js'

  export default {
    name: 'sy-region',
    components: {
      scity,
      RegionTreeCascade
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      ...regionProps,
      cityApi: {
        type: Object,
        default: Api
      },
      // 设定高度
      height: {
        type: String,
        default: function () {
          if (this.size === 'mini') {
            return 30
          }
          return '32'
        }
      }
    },
    computed: {
      optionalTabs () {
        let optionalTabs = ''
        let cityTabs = [
          {key: 'showProvince', value: 'p'},
          {key: 'showCity', value: 'c'},
          {key: 'showCounty', value: 'a'},
          {key: 'showTown', value: 's'}
        ]
        if (this.showProvince) {
          optionalTabs += cityTabs[0].value
        }
        if (this.showCity) {
          optionalTabs += cityTabs[1].value
        }
        if (this.showCounty) {
          optionalTabs += cityTabs[2].value
        }
        if (this.showTown) {
          optionalTabs += cityTabs[3].value
        }
        // for (let i = 0; i < cityTabs.length; i++) {
        //   if (this.showProvince) 
        //   if (cityTabs[i].key) {
        //     optionalTabs += cityTabs[i].value
        //   } else {
        //     break
        //   }
        // }
        return optionalTabs
      },
      // 第一次回填
      selectedIds () {
        const list = this.value || []
        return list.map && list.map((item) => {
          if (item.cityCode) {
            return item.cityCode
          } else {
            return item.provinceCode
          }
        })
      },
      areaData () {
        const value = this.value || {}
        return {
          province: {
            name: value.provinceName,
            code: value.provinceCode
          },
          city: {
            name: value.cityName,
            code: value.cityCode
          },
          area: {
            name: value.countyName,
            code: value.countyCode
          },
          street: {
            name: value.townName,
            code: value.townCode
          }
        }
      },
      regionText () {
        const {value, isPureText, radio} = this
        return isPureText ? initValue(value, {radio}) : value
      }
    },
    methods: {
      changeArea (data) {
        let province = data.province || {}
        let city = data.city || {}
        let area = data.area || {}
        let street = data.street || {}
        let _data = {
          provinceCode: province.code,
          provinceName: province.name,
          cityCode: city.code,
          cityName: city.name,
          countyCode: area.code,
          countyName: area.name,
          townCode: street.code,
          townName: street.name,
          _update: true
        }
        this.$emit('change', _data)
        this.$emit('validateField')
      },
      updateArea (area) {
        let _area = []
        area.forEach((item) => {
          let parent = item.parent || {}
          if (parent && parent.id) {
            _area.push({
              cityCode: item.id,
              cityName: item.name,
              provinceCode: parent.id,
              provinceName: parent.name
            })
          } else {
            if (item.id === '00') {
              _area.push({provinceCode: item.id, provinceName: item.name})
            } else {
              item.childList.forEach((city) => {
                _area.push({
                  cityCode: city.id,
                  cityName: city.name,
                  provinceCode: item.id,
                  provinceName: item.name
                })
              })
            }
          }
        })
        this.$emit('change', _area)
        this.$emit('validateField')
      },
      clearAll () {
        this.$emit('change', '')
        this.$emit('validateField')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .administrative-regions {
    // height: 32px;
    ::v-deep .sy-tc-selector__wrap,
    .sy-tc-selector {
      width: 100% !important;
    }

    ::v-deep .sy-region {
      .sy-tc-selector {
        width: 100% !important;
      }
    }

    ::v-deep .sy-magic-input .sy-magic-input__input.el-input input {
      font-size: 13px;
    }

    ::v-deep .area-input {
      border: 1px solid #ddd;
      border-radius: 4px;
    }
  }
</style>
